// src/pages/Admin/PageLayout.js
import React from 'react';
import BackButton from '../components/common/BackButton';
import PageTitle from '../components/common/PageTitle';
import './PageLayout.css';

const PageLayout = ({ title, children }) => {
  return (
    <div className="container-fluid p-3">
      {title && (
        <div className="page-title-container d-flex align-items-center mb-3">
          <BackButton />
          <PageTitle title={title} className="ms-3" />
        </div>
      )}
      <div>{children}</div>
    </div>
  );
};

export default PageLayout;
